/*
 * Copyright © 2023 Broadcom. All rights reserved. The term “Broadcom” refers to Broadcom Inc. and/or its subsidiaries. All trademarks, trade names, service marks, and logos referenced herein belong to their respective companies.
 * This software and all information contained therein is confidential and proprietary and shall not be duplicated, used, disclosed or disseminated in any way except as authorized by the applicable license agreement, without the express written permission of Broadcom. All authorized reproductions must be marked with this language.
 * EXCEPT AS SET FORTH IN THE APPLICABLE LICENSE AGREEMENT, TO THE EXTENT PERMITTED BY APPLICABLE LAW OR AS AGREED BY BROADCOM IN ITS APPLICABLE LICENSE AGREEMENT, BROADCOM PROVIDES THIS DOCUMENTATION “AS IS” WITHOUT WARRANTY OF ANY KIND, INCLUDING WITHOUT LIMITATION, ANY IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, OR NONINFRINGEMENT. IN NO EVENT WILL BROADCOM BE LIABLE TO THE END USER OR ANY THIRD PARTY FOR ANY LOSS OR DAMAGE, DIRECT OR INDIRECT, FROM THE USE OF THIS DOCUMENTATION, INCLUDING WITHOUT LIMITATION, LOST PROFITS, LOST INVESTMENT, BUSINESS INTERRUPTION, GOODWILL, OR LOST DATA, EVEN IF BROADCOM IS EXPRESSLY ADVISED IN ADVANCE OF THE POSSIBILITY OF SUCH LOSS OR DAMAGE.
 */
import React, { Component } from "react";
import { ShowMoreIcon } from "../ui-components/uim-components";
import { Popover } from "@mineral/core";
import "./breadcrumbs.less";

class BreadcrumbOverflow extends Component {
  state = {
    open: false,
    anchorEl: null,
  };
  handleTouchTap = (event) => {
    event.preventDefault();
    this.setState({
      open: true,
      anchorEl: event.currentTarget,
    });
  };
  handleRequestClose = () => {
    this.setState({
      open: false,
      anchorEl: null,
    });
  };

  render() {
    let home = this.props.crumbs[0];
    let rest = this.props.crumbs.slice(1, -2);
    let secondToLast = this.props.crumbs.slice(-2, -1);
    let last = this.props.crumbs.slice(-1);
    return (
      <span className="breadcrumbs" title={this.props.title}>
        {home}
        <span
          className="breadcrumb__link popover__ellipsis"
          onClick={this.handleTouchTap}
        >
          ... <ShowMoreIcon className="breadcrumb_separator" role="img" alt="Separator" aria-label={"Separator"} />
        </span>
        <Popover
          className="breadcrumb__overflow--popover"
          open={this.state.open}
          anchorEl={this.state.anchorEl}
          onClose={this.handleRequestClose}
          style={{
            overflowY: "visibile",
          }}
        >
          <div className="popover__triangle" />
          {rest}
        </Popover>
        {secondToLast}
        {last}
      </span>
    );
  }
}

export default BreadcrumbOverflow;
